import { ContentContainer } from "@twinkltech/curriculum-architect-component-library";
import { Text } from "@twinkltech/web-ui";
import { useTranslation } from "react-i18next";

import { ExploreSchemeHeader } from "@/components/ExploreSchemeHeader/ExploreSchemeHeader";
import { ExploreSubjectSchemeUnitList } from "@/components/ExploreSubjectSchemeUnitList/ExploreSubjectSchemeUnitList";
import { GenericError } from "@/components/GenericError/GenericError";
import { SchemeUnitFilters } from "@/components/SchemeUnitFilters/SchemeUnitFilters";

import { LoadingPage } from "@/pages/LoadingPage/LoadingPage";

import { EXPLORE_SCHEME_NS } from "./ExploreScheme.i18n";


import { captureAppError } from "@/utils/monitoring/sentry";
import type {
  ApiErrorResponse,
  ExploreSubjectSchemeData,
} from "@twinkltech/curriculum-architect-domain-hooks";


export const ExploreScheme = ({
  error,
  exploreScheme,
  isLoading,
}: {
  error?: ApiErrorResponse | null;
  exploreScheme?: ExploreSubjectSchemeData;
  isLoading: boolean;
}) => {
  const { t } = useTranslation(EXPLORE_SCHEME_NS);

  if (isLoading) {
    return <LoadingPage />;
  } else if (error || !exploreScheme) {
    captureAppError(error || new Error("Unknown error loading explore scheme"), {
      action: "load",
      area: "explore-scheme",
    });
    return <GenericError />;
  }
  return (
    <ContentContainer>
      <div className="flex flex-col max-w-[1200px]">
        <ExploreSchemeHeader scheme={exploreScheme.subject} />

        {/* Info block */}
        <div className="max-w-[800px] mb-5">
          <Text as="h2" variant="xl-medium">
            {t("unit-block.title")}
          </Text>
          <Text as="h2" variant="base-normal">
            {t("unit-block.description")}
          </Text>
        </div>

        {exploreScheme && exploreScheme.units && (
          <>
            <SchemeUnitFilters units={exploreScheme.units} />
            <ExploreSubjectSchemeUnitList units={exploreScheme.units} />
          </>
        )}
      </div>
    </ContentContainer>
  );
};
